import { http } from '@/api/http'
import type { RequestOptions } from '../crud'
import { createCrudService } from '../crud'

export type HREmployeeStatus = 'working' | 'fired'

/** A personnel record of the HR register (legacy employees); not a login. */
export type HREmployee = {
  id: string
  company_id: string
  party_id: string
  employee_number: string
  first_name: string
  last_name: string
  middle_name: string
  full_name: string
  phone: string
  branch_id: string
  branch_name: string
  department_id: string
  department_name: string
  job_title_id: string
  job_title_name: string
  work_location_id: string
  work_location_name: string
  profile_id: string
  profile_name: string
  /** «Фирма»: the firm the employee works for; its «Материнская компания» is the employee's (AFF | ChF). */
  legal_entity_id: string
  legal_entity_name: string
  base_salary: string
  bonus: string
  status: HREmployeeStatus
  hired_on: string
  dismissed_on: string
  passport: string
  pinfl: string
  registration_address: string
  living_address: string
  created_at: string
  updated_at: string
}

/** Every mutable field; empty strings clear optional references. */
export type HREmployeeInput = Pick<
  HREmployee,
  | 'employee_number'
  | 'first_name'
  | 'last_name'
  | 'middle_name'
  | 'phone'
  | 'branch_id'
  | 'department_id'
  | 'job_title_id'
  | 'work_location_id'
  | 'profile_id'
  | 'legal_entity_id'
  | 'base_salary'
  | 'bonus'
  | 'status'
  | 'hired_on'
  | 'dismissed_on'
  | 'passport'
  | 'pinfl'
  | 'registration_address'
  | 'living_address'
>

/** An employee profile a record may be linked to, or an expense recorded for. */
export type ProfileOption = { profile_id: string; name: string; role_code: string }

export const hrEmployeesService = {
  ...createCrudService<HREmployee, HREmployeeInput, HREmployeeInput>('hr/employees'),
  async profileOptions(search = '', options?: RequestOptions) {
    const { data } = await http.get<ProfileOption[]>('/hr/profile-options', { params: search ? { search } : {}, ...options })
    return data ?? []
  },
}
